import { createAsyncThunk } from '@reduxjs/toolkit';
import type {
  CreateQaRunInput,
  QaAllRunsParams,
  QaRunDetail,
  QaRunListPaginated,
  QaRunListResponse,
} from '../../types/qa';
import { qaService } from './services';

export const startQaRun = createAsyncThunk<
  { runId: string },
  CreateQaRunInput,
  { rejectValue: string }
>('qa/startRun', async ({ flowId, ...body }, { rejectWithValue }) => {
  try {
    return await qaService.startRun(flowId, body);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao iniciar QA run');
  }
});

export const fetchQaRuns = createAsyncThunk<QaRunListResponse, string, { rejectValue: string }>(
  'qa/fetchRuns',
  async (flowId, { rejectWithValue }) => {
    try {
      return await qaService.listRuns(flowId);
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar QA runs');
    }
  },
);

export const fetchAllQaRuns = createAsyncThunk<
  QaRunListPaginated,
  QaAllRunsParams,
  { rejectValue: string }
>('qa/fetchAllRuns', async (params, { rejectWithValue }) => {
  try {
    return await qaService.listAllRuns(params);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar histórico');
  }
});

export const fetchQaRun = createAsyncThunk<QaRunDetail, string, { rejectValue: string }>(
  'qa/fetchRun',
  async (runId, { rejectWithValue }) => {
    try {
      return await qaService.getRun(runId);
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar QA run');
    }
  },
);
